<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-9 customHeading">
          <h3>{{moduleName}}</h3>
        </div>
       
        <!--==========Class dropdown============-->
     

        <!---SEARCH BOX-->
         <div class="col-md-2">
          <div class="searchbox input-group" role="group">
          <input class="form-control search-box my-search-box" type="text" placeholder="Name" aria-label="search" v-model="filteredText">
         
          <button class="search-button btn btn-primary filter"  @click="getBackups()"><i class="fa fa-search search-icon"></i></button>
          </div>
          
        </div>
        <div class="col-md-1 Add-button" style="text-align:center">
            
            <b-spinner small v-if="isLoading" label="Loading..."></b-spinner>
           
          <a href="javascript:void(0)" v-if="!isLoading" @click="createNewBackup()">
            <div class="AddButton">
              <div class="icon">
                <i class="fas fa-arrow-alt-circle-right fa-1x" style="color: rgb(255, 50, 55);">
                </i>
              </div>
              <div data-text="Add" class="name add-btn">Backup Now </div>
            </div>
          </a>
        </div> 

       </div>
       <div class="row">
         <div class="col">
          <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
         </div>
        </div>
      <div>
        <div class="row"><div class="col">
        <table class="table table-striped table-borderless cutom-table table-striped table-sm" 
          style="font-size: 85%;">
            <thead>
              <tr>
             
                <th role="columnheader">Date</th>
                <th role="columnheader">Name</th>
                <th role="columnheader" >Actions</th>
              </tr>
            </thead>
            <tbody>
              <!--IF STUDENTS ARRAY HAS NO VALUE THEN SHOW WITHOUT SHOWING DATA-->
              <tr v-if= "backups==null" >
                <td class = "center-td" colspan="3">No Data</td>
              </tr>
              
            <tr v-else v-for="record in backups" :key=record.id>
              <td  role="cell">{{record.creationDate|moment("MMMM Do YYYY, h:mm:ss a")}}</td>
              
              <td  role="cell">{{record.name}} </td>
              <td>
                <a :href = record.filePath target="_blank">
                    <i role="button" style="color:green" class="fa fa-download"></i>
                </a>
                &nbsp;|&nbsp;
                <span @click= "passRecordToDelete(record.id)">
                  <i role="button" style="color:green" class="far fa-trash-alt"></i>
                </span>
                   
              </td>
            </tr>
          </tbody>
        </table>
      </div></div>

      

    <!--PAGINATION START-->
    <div class="row justify-content-between align-items-center">
      <div class="col-md-2">
        <div class="showPages">
          <select class="form-control" id="selClass" v-model="perPage" 
          @change="getBackups()">
            <option v-for="option in options" :key="option.value" :value="option.value">
            {{option.text}}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-8 d-flex justify-content-center">
        <div class="overflow-auto">
            <b-pagination
              v-model= "page"
              :total-rows= rows
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
      </div>

       <div class="col-md-2">
        <input class="form-control search-box page-no-search" type="text" v-bind:placeholder="page" aria-label="search" v-model.number="pageNumOnSearch" style="height:38px">
      
        <button class="search-button btn btn-primary search page-no-search-btn" @click="search()">
              GO
        </button>

       </div>
    </div>
    <!--/PAGINATION END-->	
    <!--SPINNER-->	
    <Spinner v-if="isLoading" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
    <Toaster ref = "toaster"/>
    <DeleteModal :msgForModal= "msgForModal" :apiEndPoint = "apiEndPoint" :heading = "deleteModalHeading"  :entityId = "recordToDelete"/>
   
   
     
  </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner';
import DeleteModal from '../../modals/DeleteModal';
import Toaster from '../toaster';

export default {
    name: 'Backups',
    data(){
        return{
          moduleName:'Database Backup',
     
      
          isLoading:false,
          recordToEdit :  null,
          recordToDelete:null,
          msgForModal:null,
          apiEndPoint:null,
          deleteModalHeading:null,
      
          backups:null,
        
          pageNumOnSearch:'',
          filteredText:'',
          rows:0,
           page: 1,
          options: [
            { text: 'Show 2',  value: 2 },
            { text: 'Show 10',  value: 10 },
            { text: 'Show 25',  value: 25 },
            { text: 'Show 50',  value: 50 },
            { text: 'Show 100', value: 100 }
          ],
          perPage:25     
		}
  },
 
methods:{
createNewBackup()
{
    this.isLoading  = true;
 axios.post('/backup/add',{"CompanyId":this.$auth.user().companyId,
      "PageSize":this.perPage,"Page":this.page,"Text":this.filteredText})
    .then(res=>{
      this. isLoading = false;

      if(res.data.status == 1)
      {
       this.$refs.toaster.showToast('Success','success','Backup has been created successfully');
       this.getPage();
      }
      else if(res.data.status== -1)
      {
          this.$refs.toaster.showToast('Error','danger',res.data.msg);
      }
    
    });
},

    getPage(page)
  {
    this.page = page;
    this.getBackups();
  },

 
  passRecordToDelete(id)
  {
    this.recordToDelete = id;
    this.msgForModal = "Confirm to delete !";
    this.apiEndPoint = "backup/Delete/";
    this.deleteModalHeading = "Delete"
    this.$bvModal.show('DeleteModal')

  },
 
    
   

    getBackups(){
       this.isLoading = true;
      axios.post('/backup/getall',{"CompanyId":this.$auth.user().companyId,
      "PageSize":this.perPage,"Page":this.page,"Text":this.filteredText})
    .then(res=>{
      this. isLoading = false;

      if(res.data.status == 1)
      {
       
        this.backups=res.data.data;
    
        this.rows = res.data.totalRecords;
      }
      else if(res.data.status== -1)
      {
           this.$refs.toaster.showToast('Success','danger',res.data.msg);
      }
      else {
        this.backups = null;
      
      }
    });
    },
		
   

  search(){
   
    this.page=this.pageNumOnSearch;
    this.getBackups();
  }
  },
	created(){
    this.getBackups();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components:{
    Spinner,
    DeleteModal,
    Toaster
   
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.row{
  margin-left:0px;
  margin-right:0px;
}
.col{
  padding-left:0px;
  padding-right:0px;
}
</style>